export const standardConsent: string =
   `<h1>IguideME</h1>
    <strong>This is a sample consent, be sure to fill in the blanks!</strong>
    <h2>INFORMED CONSENT</h2>

    <p>
      Dear participant,<br/>
      We ask for your cooperation in an evaluation study into educational improvement. In this document, the so-called "informed consent", we explain this study and you can indicate whether you want to cooperate. Read the text below carefully.
    </p>

    <h3>Goal of the research</h3>
    <p>
      The goal of this educational research is to study the effects of the feedback tool “IguideME” and activating learning tools (e.g. Perusall) on the learning process.<br />
      The results of this research can be used to facilitate your learning process, to improve the design of this and other courses, and for scientific publications.
    </p>

    <h3>Research description</h3>
    <p>
      To investigate the effects of using IguideME, personal data (name and student ID) and learning activity data will be collected. Based on these data, you will receive personal feedback via the IguideME dashboard in Canvas. You will also receive a predicted course grade that will be automatically calculated from the learning activity data using an algorithm. To investigate the effects of activating learning tools, the quality of assignments will be assessed and the results of a short questionnaire that scores motivation and learning behavior will be compared between the beginning and at the end of the course. For presentations purposes, all data will be anonymized.
    </p>

    <h3>Voluntariness</h3>
    <p>
      The participation in this research is voluntary. In the case that you decline to participate or stop your participation the data that you have generated will not be used in the research. You are free to stop your participation in this research without specifying a reason by informing dr. Erwin van Vliet.
    </p>

    <h3>Insurance</h3>
    <p>
      This research brings no risks for your health and safety and in this case the regular liability insurance of the University of Amsterdam is valid.
    </p>

    <h3>Additional Information</h3>
    <p>
      In case of any questions about this research please contact: <b>TEACHER NAME</b> (<b>ROLE</b>), phone <b>PHONE-NUMBER</b>, e-mail <b>EMAIL@DOMAIN.XYZ</b>
    </p>

    <h2>CONSENT FORM</h2>
    <p>
      Here you will be asked to sign the Informed consent.
      <ul>
        <li>
          By choosing <i>"Yes"</i> in this form, you declare that you have read the document entitled “informed consent IguideME”, understood it, and confirm that you agree with the procedure as described.<br />
        </li>
        <li>
          By choosing <i>"No"</i> in the form, you declare that you have read the document entitled “informed consent IguideME”, understood it, and confirm that you do not want to participate in this study.
        </li>
      </ul>
    </p>
`;
